import React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import ButtonAppBar from './components/app-bar/Main';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

import Home from './components/Home/Home'
import Footer from './components/Footer'
import Error from './components/Error'
import { isLocalDevelopment } from './constants/environment';
import { createLazyPage } from './components/LazyPage';
import { ResumeBuilderSkeleton } from './components/CreateResume/LoadingSkeleton';
import ReactGA from "react-ga4";
const ResumeUI = createLazyPage(() => import('./components/Resume'), 'resume');
const CreateResume = createLazyPage(() => import('./components/CreateResume'), 'resume builder', ResumeBuilderSkeleton);
const FeedbackAdmin = createLazyPage(() => import('./components/FeedbackAdmin'), 'feedback administration');
const Projects = createLazyPage(() => import('./components/Projects'), 'projects');
const AgeCalculator = createLazyPage(() => import('./components/Tools/AgeCalculator'), 'age calculator');
const UpiExpenseCalc = createLazyPage(() => import('./components/Tools/UpiExpenseCalc'), 'UPI expense calculator');
const ShareRecipe = createLazyPage(() => import('./components/ChefCorner/ShareRecipe'), 'recipe sharing');
const RecipePage = createLazyPage(() => import('./components/ChefCorner/RecipePage'), 'recipes');
const MEASUREMENTID = "G-3V4GDN613C"; // OUR_TRACKING_ID

ReactGA.initialize(MEASUREMENTID, {
  // debug: true, // Enable debug mode
});




function App() {
  // Use Box with sx instead of legacy makeStyles class
  const theme = createTheme();
  // initial pageview will be sent on route change via GoogleAnalyticsTracker

  function GoogleAnalyticsTracker() {
    const location = useLocation();
    React.useEffect(() => {
      if (!isLocalDevelopment()) {
        ReactGA.send({ hitType: "pageview", page: location.pathname + location.search, title: document.title });
      }
    }, [location]);
    return null;
  }

  return (
    <ThemeProvider theme={theme}>
  {/* Opt-in to React Router v7 future flags to avoid deprecation warnings */}
  <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>

        {/* Make the app a full-height flex column so footer stays at bottom on short pages */}
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>

          {/* Main content should grow to take available space */}
          <Box component="main" sx={{ flex: 1 }}>
            <ButtonAppBar />
            <GoogleAnalyticsTracker />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/age-calculator" element={<AgeCalculator />} />
              <Route path="/upi-expense-cal" element={<UpiExpenseCalc />} />
              <Route path="/share" element={<ShareRecipe />} />
              <Route path="/recipes" element={<RecipePage />} />
              <Route path="/resume" element={<ResumeUI />} />
              <Route path="/create-resume" element={<CreateResume />} />
              <Route path="/feedback-admin" element={<FeedbackAdmin />} />

              <Route path="*" element={<Error />} />
            </Routes>
          </Box>

          <Footer title="We can connect here" description="Made with love" />

        </Box>

      </Router>
    </ThemeProvider>
  );
}

export default App
